/* React */
import React, { useEffect, useRef, useState } from "react";

/* React-Redux */
import { useSelector } from "react-redux";
import { RootState } from "src/redux/store";

/* Components */
import OptionsLabel from "src/components/insights/insights-options/options-label/OptionsLabel";
import SankeyDiagramOptions from "src/components/insights/insights-options/sankey-diagram-options/SankeyDiagramOptions";
import SurvivalAnalysisOptions from "src/components/insights/insights-options/survival-analysis/SurvivalAnalysisOptions";
import DescriptiveStatisticsOptions from "src/components/insights/insights-options/descriptive-statistics/DescriptiveStatisticsOptions";

/* Constants */
import { ChartType } from "src/shared/constants/charts/Chart";

/* Stylesheet */
import styles from "./InsightsOptions.module.scss";

const InsightsOptions: React.FC = () => {
  const contentContainerRef = useRef<HTMLDivElement | null>(
    null
  );

  const insightsFilterOptionsState = useSelector(
    (state: RootState) => state.insightsFilterOptions
  );

  const { options } = insightsFilterOptionsState;

  const [showOptions, setShowOptions] =
    useState<boolean>(false);

  const handleShowOptions = () => {
    setShowOptions((prev) => !prev);
  };

  useEffect(() => {
    if (!contentContainerRef.current) return;
    contentContainerRef.current.scrollIntoView({
      behavior: "smooth",
      block: "end",
    });
  }, [showOptions]);

  const mapTypeToComponent = (type: string) => {
    switch (type) {
      case ChartType.BAR:
      case ChartType.HISTOGRAM:
        return <DescriptiveStatisticsOptions />;
      case ChartType.SCATTER:
        return <SurvivalAnalysisOptions />;
      case ChartType.SANKEY:
        return <SankeyDiagramOptions />;
      default:
        return undefined;
    }
  };

  return (
    <div className={styles.insights_options}>
      {options ? (
        <OptionsLabel onClick={handleShowOptions} />
      ) : undefined}
      {showOptions ? (
        <div
          ref={contentContainerRef}
          className={styles.content_container}
        >
          {options
            ? mapTypeToComponent(options)
            : undefined}
        </div>
      ) : undefined}
    </div>
  );
};

export default InsightsOptions;
